import React from 'react';
import classnames from 'classnames';

export interface DrawerSubTitleProps {
  tag?: string;
  className?: string;
}

const DrawerSubTitle: React.FunctionComponent<DrawerSubTitleProps> = ({
  tag: Tag = 'h6',
  children,
  className = '',
  ...otherProps
}) => {
  return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    <Tag
      className={classnames('mdc-drawer__subtitle', className)}
      {...otherProps}
    >
      {children}
    </Tag>
  );
};

export default DrawerSubTitle;
